import React from 'react';

import {ParticipantList} from './List';

export const Participants = () => <ParticipantList />;
